module.exports = __webpack_public_path__ + "img/DE00182.c2f40e4d.png";